import { IPagination } from 'app/types/common';

export interface IFixtureMatchImportsState {
  readonly fixtureMatchImportsById?: any;
  readonly fixtureMatchImportIds?: string[];
  readonly hasLoaded?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasSaved?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly selectFixtureMatchImportLoading?: boolean;
  readonly hasLoaded?: boolean;
  readonly showAddFixtureMatchImport?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationFixtureMatchImportIds?: string[];
  readonly currentFixtureMatchImportId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IFixtureMatchImportsSelector extends IFixtureMatchImportsState {
  readonly currentFixtureMatchImport?: any;
  readonly currentFormFixtureMatchImport?: any;
  readonly fixtureMatchImportsFilteredByTagInSelectFormat?: any;
  readonly fixtureMatchImportsByIdInSelectFormat?: any;
  readonly fixtureMatchImportsFilteredByOrganisationInSelectFormat?: any;
}

export enum FixtureMatchImportsActionTypes {
  GET_ALL_FIXTURE_MATCH_IMPORTS_REQUESTED = 'redux-app/fixture-match-imports/GET_ALL_FIXTURE_MATCH_IMPORTS_REQUESTED',
  GET_ALL_FIXTURE_MATCH_IMPORTS_PENDING = 'redux-app/fixture-match-imports/GET_ALL_FIXTURE_MATCH_IMPORTS_PENDING',
  GET_ALL_FIXTURE_MATCH_IMPORTS_SUCCESS = 'redux-app/fixture-match-imports/GET_ALL_FIXTURE_MATCH_IMPORTS_SUCCESS',
  GET_ALL_FIXTURE_MATCH_IMPORTS_FAIL = 'redux-app/fixture-match-imports/GET_ALL_FIXTURE_MATCH_IMPORTS_FAIL',
  GET_FIXTURE_MATCH_IMPORT_REQUESTED = 'redux-app/fixture-match-imports/GET_FIXTURE_MATCH_IMPORT_REQUESTED',
  GET_FIXTURE_MATCH_IMPORT_PENDING = 'redux-app/fixture-match-imports/GET_FIXTURE_MATCH_IMPORT_PENDING',
  GET_FIXTURE_MATCH_IMPORT_SUCCESS = 'redux-app/fixture-match-imports/GET_FIXTURE_MATCH_IMPORT_SUCCESS',
  GET_FIXTURE_MATCH_IMPORT_FAIL = 'redux-app/fixture-match-imports/GET_FIXTURE_MATCH_IMPORT_FAIL',
  UPDATE_FIXTURE_MATCH_IMPORT_REQUESTED = 'redux-app/fixture-match-imports/UPDATE_FIXTURE_MATCH_IMPORT_REQUESTED',
  UPDATE_FIXTURE_MATCH_IMPORT_PENDING = 'redux-app/fixture-match-imports/UPDATE_FIXTURE_MATCH_IMPORT_PENDING',
  UPDATE_FIXTURE_MATCH_IMPORT_SUCCESS = 'redux-app/fixture-match-imports/UPDATE_FIXTURE_MATCH_IMPORT_SUCCESS',
  UPDATE_FIXTURE_MATCH_IMPORT_FAIL = 'redux-app/fixture-match-imports/UPDATE_FIXTURE_MATCH_IMPORT_FAIL',
  CREATE_FIXTURE_MATCH_IMPORT_REQUESTED = 'redux-app/fixture-match-imports/CREATE_FIXTURE_MATCH_IMPORT_REQUESTED',
  CREATE_FIXTURE_MATCH_IMPORT_PENDING = 'redux-app/fixture-match-imports/CREATE_FIXTURE_MATCH_IMPORT_PENDING',
  CREATE_FIXTURE_MATCH_IMPORT_SUCCESS = 'redux-app/fixture-match-imports/CREATE_FIXTURE_MATCH_IMPORT_SUCCESS',
  CREATE_FIXTURE_MATCH_IMPORT_FAIL = 'redux-app/fixture-match-imports/CREATE_FIXTURE_MATCH_IMPORT_FAIL',
  DELETE_FIXTURE_MATCH_IMPORT_REQUESTED = 'redux-app/fixture-match-imports/DELETE_FIXTURE_MATCH_IMPORT_REQUESTED',
  DELETE_FIXTURE_MATCH_IMPORT_PENDING = 'redux-app/fixture-match-imports/DELETE_FIXTURE_MATCH_IMPORT_PENDING',
  DELETE_FIXTURE_MATCH_IMPORT_SUCCESS = 'redux-app/fixture-match-imports/DELETE_FIXTURE_MATCH_IMPORT_SUCCESS',
  DELETE_FIXTURE_MATCH_IMPORT_FAIL = 'redux-app/fixture-match-imports/DELETE_FIXTURE_MATCH_IMPORT_FAIL',
  SELECT_FIXTURE_MATCH_IMPORT_REQUESTED = 'redux-app/fixture-match-imports/SELECT_FIXTURE_MATCH_IMPORT_REQUESTED',
}

export default null;
